// @ts-nocheck
import { ModalState, ModalActions, ModalAction } from '../../types/modal';
import { ModalTypes } from '../../const/ModalTypes';

const initialState: ModalState = {
  isModalOpen: false,
  modalType: null,
  modalParameters: null,
  onCreateEntity: null,
  onCreateEntities: null,
};

export const modalReducer = (state = initialState, action: ModalAction): ModalState => {
  switch (action.type) {
    case ModalActions.SET_MODAL_STATE: {
      const { isModalOpen, modalType, modalParameters, onCreateEntity, onCreateEntities } =
        action.payload;
      return {
        ...state,
        isModalOpen,
        modalType,
        modalParameters,
        onCreateEntity,
        onCreateEntities,
      };
    }
    default:
      return state;
  }
};
